import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import {
  AttachmentSection,
  Button,
  Chip,
  DocumentsList,
  FormFieldSet,
  Modal,
  showToast,
  useFormHandler,
} from "../../../../../../components";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
import { uploadStart } from "../../../../../../redux/slices/universal/fileUploadSlice";
import { addDocumentStart } from "../../../../../../redux/slices/universal/documentsSlice";
import { documentOptions } from "../../../../../../assets/data/projectData";
import { RecordStatus } from "../../../../../../assets/data/enumData";
import { addCurrentPlacement } from "../../../../../../redux/slices/placements/placementsSlice";
import { useEffect, useState } from "react";
import axiosRequest from "../../../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../../../redux/apiConfig";
import { transformFiles } from "../../../../../../utils/transformFiles";
const Documents = ({ onCancel, currentPlacement, setActiveTab, editData }) => {
  const isEditable = !!editData;

  const [fetchPerticularData, setFetchPerticularData] = useState(null);
  const { employeeProfileUiid, currentEmployee } = useSelector(
    (state) => state.employee,
  );
  const { userData: loginUserData } = useLoginUser();
  const organizationId = loginUserData?.organizationId.uiid;
  const loginUserUiid = loginUserData?.uiid;
  const dispatch = useDispatch();
  const [attachmentModal, setAttachmentModal] = useState(false);
  const {
    formData,
    errors,
    handleChange,
    validateAllFields,
    setErrors,
    setFormData,
  } = useFormHandler(
    {
      attachments: [
        {
          id: uuidv4(),
          attachmentName: "",
          attachmentComments: "",
          documentType: "",
          documentStatus: "",
          chooseFiles: [],
        },
      ],
    },
    {
      attachments: [
        {
          // attachmentName: { type: "text", required: true },
          // attachmentComments: { type: "text", required: true },
          documentType: { type: "text", required: true },
          documentStatus: { type: "select", required: true },
          chooseFiles: {
            type: "file",
            required: true,
            // allowedFiles: [
            //   { ext: "png", mime: "image/png" },
            //   { ext: "txt", mime: "text/plain" },
            // ],
          },
        },
      ],
    },
  );
  console.log("errors", errors);
  console.log("formDat", formData);
  // This handleAddRow approach directly manipulates state without triggering validation reset
  const handleAddRow = () => {
    // Store current errors
    const currentErrors = { ...errors };
    setFormData({
      ...formData,
      documentRows: [
        ...formData.documentRows,
        {
          id: uuidv4(),
          attachmentName: "",
          attachmentComments: "",
          documentType: "",
          documentStatus: "",
          chooseFiles: [],
        },
      ],
    });
    setErrors(currentErrors);
  };

  const handleRemoveRow = (id) => {
    if (formData.documentRows.length > 1) {
      const indexToRemove = formData.documentRows.findIndex(
        (row) => row.id === id,
      );
      const newDocumentRows = formData.documentRows.filter(
        (row) => row.id !== id,
      );
      setFormData({
        ...formData,
        documentRows: newDocumentRows,
      });
      if (errors?.documentRows) {
        setErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          if (newErrors.documentRows) {
            const updatedRowErrors = [...newErrors.documentRows];
            updatedRowErrors.splice(indexToRemove, 1);
            newErrors.documentRows = updatedRowErrors;
          }
          return newErrors;
        });
      }
    }
  };

  const getAttachmentError = (index, field) => {
    return errors?.attachments?.[index]?.[field] || "";
  };

  const handleFieldChange = (index, field, value) => {
    handleChange(`attachments[${index}].${field}`, value);
  };
  const handleSave = () => {
    const isValid = validateAllFields();
    if (!isValid) {
      showToast("Please fill all the required fields before saving", "error");
      return;
    }
    // Filter valid document entries
    const cleanAttachments = formData.attachments.filter(
      (att) =>
        att.attachmentName?.trim() !== "" ||
        att.documentType?.trim() !== "" ||
        (att?.chooseFiles && att?.chooseFiles.length > 0),
    );

    // Map files with their parent doc id
    const cleanAttachmentsFiles = cleanAttachments.flatMap((doc) =>
      doc?.chooseFiles.map((file) => {
        file.id = doc.id;
        return file;
      }),
    );
    const uiid = fetchPerticularData?.uiid ?? "";
    if (!cleanAttachmentsFiles.length) return;
    dispatch(
      uploadStart({
        uploadType: "multiple",
        field: "doc",
        uiid: uiid,
        entity: "placements",
        category: "Documents",
        coll: "Placement",
        doc: cleanAttachmentsFiles,
        onSuccess: (fileData) => {
          const attachmentsPayload = cleanAttachments.map((clean) => {
            return {
              addedBy: loginUserUiid,
              docType: clean.documentType,
              parent: { employee: employeeProfileUiid },
              ref: {
                id: uiid,
                entity: "Placement",
                path: "documents",
              },
              file: (clean.chooseFiles || []).map((file) => {
                const matchedFile = fileData.find(
                  (f) => f?.fileRefId === clean.id && f.key,
                );
                return {
                  name: clean.attachmentName,
                  comments: clean.attachmentComments,
                  docStatus: clean.documentStatus,
                  keys: matchedFile ? [matchedFile.key] : [],
                };
              }),
            };
          });
          dispatch(
            addDocumentStart({
              coll: "Document",
              refColl: "Placement",
              refId: uiid,
              refField: "documents",
              refPatchId: "",
              payload: {
                addedBy: loginUserUiid,
                attachments: attachmentsPayload,
              },
              onSuccess: async () => {
                dispatch(
                  addCurrentPlacement({
                    documents: attachmentsPayload,
                  }),
                );
                setActiveTab((prev) => prev + 1);
                // handleModalClose(); // Optional: uncomment if you want to close the modal on success
              },
            }),
          );
        },
      }),
    );
  };
  useEffect(() => {
    const documents = Array.isArray(currentPlacement?.documents)
      ? currentPlacement.documents
      : [];

    documents.forEach((data, index) => {
      const file =
        Array.isArray(data?.file) && data.file.length > 0 ? data.file[0] : {};

      handleFieldChange(index, "documentName", file.name || "");
      handleFieldChange(index, "comments", file.comments || "");
      handleFieldChange(index, "active", file.docStatus ?? false);
      handleFieldChange(index, "documentType", data?.docType || "");
    });
  }, [currentPlacement]);

  useEffect(() => {
    const fetchData = async () => {
      const uiid =
        currentPlacement?.uiid ??
        editData?.uiid ??
        currentPlacement?.data?.doc?.uiid ??
        "";
      if (!uiid) return;
      const filter = {
        uiid: { type: "NONE", value: uiid },
      };
      try {
        const response = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.PLACEMENTS.GET_BY_UIID,
          params: {
            coll: "Placement",
            ref: "Document",
            fil: JSON.stringify(filter),
            ret: "documents uiid",
            // ref: "InvDoc",
            // incl: "uiid businessName",
          },
        });
        const data = response?.data?.data;
        if (data) {
          //  const invoices = data?.invoices || {};
          setFetchPerticularData(data);
        }
      } catch (error) {
        setFetchPerticularData(null);
        console.error("Failed to fetch placement data:", error);
      }
    };
    fetchData();
  }, [currentPlacement, isEditable]);
  const combineAttachments = fetchPerticularData
    ? transformFiles(fetchPerticularData?.documents || [])
    : [];
  return (
    // <div className="px-4 py-4 border-[1px] border-neutrals-50 rounded-b min-h-[69vh] overflow-auto">
    <div className="px-4 py-4 border-[1px] border-neutrals-50 rounded-b overflow-auto">
      <div>
        <AttachmentSection
          attachments={formData.attachments}
          onChange={(newAttachments) =>
            setFormData({ ...formData, attachments: newAttachments })
          }
          getAttachmentError={getAttachmentError}
          showNameField={true}
          showCommentsField={true}
          showDocumentStatusField={true}
          showDocumentTypeField={true}
        />
      </div>
      {combineAttachments.length > 0 && (
        <div
          className=" flex rounded-md items-center cursour-pointer"
          onClick={() => setAttachmentModal(!attachmentModal)}
        >
          <Chip
            label={`Attachments:-${combineAttachments.length}`}
            icon={"docs"}
            iconPosition={"before"}
          />
        </div>
      )}
      <Modal
        isOpen={attachmentModal}
        onClose={() => setAttachmentModal(false)}
        // title="Attachment View"
        // width="max-w-5xl"
        width="max-w-2xl"
        title={"Document Details"}
      >
        {/* <div className="flex flex-col justify-center items-center gap-8">
              <h6>attachement Details</h6> */}
        <DocumentsList data={combineAttachments} />
        {/* <Button
                title={"Close"}
                onClick={() => setAttachmentModal(false)}
              /> */}
        {/* </div> */}
      </Modal>
      <div className="flex justify-end gap-4 mt-6">
        <Button title={"Cancel"} variant="outlined" onClick={""} />
        <Button title={"Save"} onClick={() => handleSave()} />
      </div>
    </div>
  );
};

export default Documents;
